import { useState } from 'react';
import { technologies } from '../constant';

const Tech = () => {
    const [hoveredTech, setHoveredTech] = useState(null);

    return (
        <div className="flex flex-row flex-wrap justify-center gap-10 my-16 max-w-2xl mx-auto px-3.5 md:p-0">
            {technologies.map((tech) => (
                <div
                    key={tech.name}
                    onMouseEnter={() => setHoveredTech(tech.name)}
                    onMouseLeave={() => setHoveredTech(null)}
                    className='relative'
                >
                    <img
                        className="cursor-pointer w-16 h-16 rounded-[50%] border-2 shadow-xl bg-transparent p-2"
                        src={tech.icon}
                        alt="techs"
                    />
                    {hoveredTech === tech.name && (
                        <div className="absolute top-[20] text-center text-white font-semibold font-poppins">{tech.name}</div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Tech;
